import React from 'react';
import { Section, SectionHeading } from '../Section';
import { CtaButton } from '../CtaButton';
const findings = ['A patient presents with severe tooth wear.', 'Loss of tooth structure.', 'Functional concerns.', 'An extensive rehabilitation.'];
const questions = ['What should I evaluate first?', 'Which clinical signals actually matter?', 'Should I consider changing the VDO?', 'What occlusal factors should I prioritize?', 'Am I overlooking something important?'];
export function ComplexCase() {
  return <Section tone="dark" data-id="element-127" data-mp="3rn7bflnzjv02">
      <SectionHeading eyebrow="When a complex case sits in your chair…" title="Do you know exactly where to start?" data-id="element-128" data-mp="3rnh2zdooia7v" />

      <div className="mt-10 grid gap-4 sm:grid-cols-2" data-id="element-129" data-mp="3hv1lsil7hpo1">
        <ul className="space-y-3 rounded-2xl border border-white/10 bg-navy-950 p-5 sm:p-6" data-id="element-130" data-mp="3hti3ynjwj6k5">
          {findings.map(finding => <li key={finding} className="flex gap-3 text-[15px] leading-snug text-slate-200" data-id="element-131" data-mp="37y6m3wd75j86">
              <span className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-gold-500" aria-hidden="true" data-id="element-132" data-mp="1nz86661aeadw" />
              {finding}
            </li>)}
        </ul>

        <div className="rounded-2xl border border-gold-500/25 bg-navy-950 p-5 sm:p-6" data-id="element-133" data-mp="1j30xw6lf4mss">
          <p className="text-[11px] font-bold uppercase tracking-[0.18em] text-gold-500" data-id="element-134" data-mp="1xvuq8slsgxev">
            And suddenly, several questions appear at once
          </p>
          <ul className="mt-4 space-y-3" data-id="element-135" data-mp="15abbi11z9fv5">
            {questions.map(question => <li key={question} className="font-display text-[16px] italic leading-snug text-white sm:text-lg" data-id="element-136" data-mp="10ayfapp7uwfw">
                “{question}”
              </li>)}
          </ul>
        </div>
      </div>

      <div className="mx-auto mt-10 max-w-2xl space-y-3 text-center text-[15px] leading-relaxed text-slate-300 sm:text-lg" data-id="element-137" data-mp="1a6i6wzwqz8yu">
        <p data-id="element-138" data-mp="hk78nvwm5k57">This is where even experienced dentists can feel uncertain.</p>
        <p className="text-white" data-id="element-139" data-mp="hhuqpiquv9s5">Not because they lack knowledge.</p>
        <p data-id="element-140" data-mp="177ba0g2fvxx1">
          But because complex cases require you to organize multiple variables into a sequence of
          clinical decisions.
        </p>
        <p className="font-semibold text-gold-400" data-id="element-141" data-mp="1fzmqb93ua4za">
          That’s why Dr. Karito created the Oclusion Clinical Playbook™ — a practical system designed
          to help you structure your clinical reasoning before moving forward.
        </p>
      </div>

      <div className="mt-9 flex justify-center" data-id="element-142" data-mp="ob1q3c4uwd54">
        <CtaButton label="Get my Clinical Playbook™" subLabel="One payment of $27 · Instant access" data-id="element-143" data-mp="s9se8trcgkg3" />
      </div>
    </Section>;
}